module.exports = __webpack_public_path__ + "static/media/intro.de040934.mp3";